import React from "react";
import Star from "../Star";
import { container } from "./styles.module.scss";

export default function StarRating({ rating, fillColor, size }) {
  const stars = new Array(5).fill(1).map((_, index) => {
    const isFilled = index < rating;
    return (
      <Star key={index} isFilled={isFilled} fillColor={fillColor} size={size} />
    );
  });

  return (
    <div className={container}>
      {stars}
      <span className="srOnly">{rating} of 5 stars</span>
    </div>
  );
}
